export const healthQuestionsDisabled = (healthQuestionsList, healthQuestionsReponses) =>
	healthQuestionsList.length > 0 &&
	healthQuestionsList.some((qu) => {
		return (
			healthQuestionsReponses?.[qu.id] === undefined &&
			(!qu.dependency || qu.dependency(healthQuestionsReponses))
		);
	});

export const healthQuestionsConditions = (question, healthQuestionsReponses) =>
	!question.dependency || question.dependency(healthQuestionsReponses);

export const healthQuestionsList = [
	{
		id: 1,
		description:
			'¿En los últimos 5 años, ¿te has sometido a pruebas de diagnóstico de alguna de las siguientes enfermedades (cáncer*, infarto de miocardio, accidente cerebrovascular, insuficiencia renal, cirugía cardiaca, trasplante de órganos vitales como corazón, pulmón hígado, páncreas o medula ósea), o has realizado tratamiento médico durante más de 7 días, o has tenido que interrumpir tu rutina diaria por motivos de salud durante más de 7 días?',
		warning:
			'*Según el Real Decreto-ley 5/2023, de 28 de junio sobre el olvido oncológico, no tiene usted obligación de responder que si a esta pregunta una vez transcurridos cinco años desde la finalización del tratamiento radical de la patología oncológica sin recaída posterior.',
		type: 'BOOLEAN',
		dependencyQuestionNumber: [],
		dependency: undefined,
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: 'SALUD',
		blocksContinueValue: true,
	},
	{
		id: 2,
		description: '¿Has realizado tratamiento médico durante más de 7 días?',
		type: 'BOOLEAN',
		dependencyQuestionNumber: ['ALL'],
		dependency: (responses) => {
			return responses[1] === 'NO MOSTRAR NUNCA'; // Con esta condición se consigue que no se muestre esta pregunta que es lo que pidieron el 20/03/25
		},
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: 'SALUD',
		blocksContinueValue: true,
	},
	{
		id: 3,
		description:
			'¿Has tenido que interrumpir tu rutina diaria por motivos de salud durante más de 7 días?',
		type: 'BOOLEAN',
		dependencyQuestionNumber: ['ALL'],
		dependency: (responses) => {
			return responses[1] && responses[2];
		},
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: 'SALUD',
		blocksContinueValue: true,
	},
];
